/* =========================================================================
   DDS AUTH & SUPABASE INTEGRATION
   Handles OTP SMS, Magic Link, and UI interactions
========================================================================= */

  const SUPABASE_URL = "https://dvojdpygwauvhsyfgyfb.supabase.co";
  const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR2b2pkcHlnd2F1dmhzeWZneWZiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU4NzU4ODcsImV4cCI6MjA4MTQ1MTg4N30.DORS2xJfPaUX6jLcORUZ4oFh1XqUcr0ILdP40jZrH0I";
  
if (!window.supabase) {
  console.warn("Supabase SDK nu este încărcat în memorie. Verifică theme.liquid");
} else {
  // Inițializare garantată ASYNC / SYNC
  window.ddsSupabase = window.supabase.createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
    auth: {
      persistSession: true,
      storage: window.localStorage,
      autoRefreshToken: true,
      detectSessionInUrl: true
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  // Ascundem contul nativ Shopify si trimitem spre dashboard-ul nostru
  const currentPath = window.location.pathname;
  if (
    currentPath === '/account' ||
    currentPath === '/account/login' ||
    currentPath === '/account/register' ||
    currentPath.startsWith('/account/')
  ) {
    // Verificam daca vine de la /account/logout — lăsăm să se execute
    if (!currentPath.includes('logout')) {
      window.location.replace('/pages/cont');
    }
  }

  let globalCurrentPhone = ""; // Salvează nr de telefon temporar
  let globalCurrentEmail = ""; // Salvează adresa de email temporar
  let currentMode = 'login'; // 'login' sau 'signup'
  let smsFailCount = 0; // Counter eșecuri SMS pentru fallback email
  const SMS_COOLDOWN_NORMAL = 60;
  const SMS_COOLDOWN_BUSY = 180;
  let currentCooldown = SMS_COOLDOWN_NORMAL;

  // --- Anti-Abuse: Client-side SMS Throttle ---
  const SMS_THROTTLE_MS = 60000; // 60s minim între cereri per telefon
  const getSmsThrottleKey = (phone) => `dds_sms_ts_${phone.slice(-4)}`;
  const isSmsThrottled = (phone) => {
    const key = getSmsThrottleKey(phone);
    const last = parseInt(localStorage.getItem(key) || '0', 10);
    return (Date.now() - last) < SMS_THROTTLE_MS;
  };
  const markSmsSent = (phone) => {
    localStorage.setItem(getSmsThrottleKey(phone), String(Date.now()));
  };

  // --- Anti-Abuse: Strict Romanian Phone Validation ---
  const isValidRomanianMobile = (digitsOnly) => {
    // Acceptă DOAR numere mobile românești: 07[2-9]X XXX XXX
    // Respinge 070, 071 (nu sunt alocate), numere de test, non-RO
    let localNum = digitsOnly;
    if (localNum.startsWith('+40')) localNum = '0' + localNum.slice(3);
    else if (localNum.startsWith('40') && localNum.length === 12) localNum = '0' + localNum.slice(2);
    // Trebuie să fie exact 10 cifre, format 07[2-9]XXXXXXX
    if (!/^07[2-9]\d{7}$/.test(localNum)) return false;
    // Reject numere de test cunoscute
    const testNumbers = ['0700000000','0720000000','0730000000','0740000000','0750000000','0760000000','0770000000','0780000000','0790000000'];
    if (testNumbers.includes(localNum)) return false;
    return true;
  };

  // 2. DOMElements
  const modal = document.getElementById('dds-auth-overlay');
  const closeBtn = document.getElementById('dds-auth-close');
  const tabBtns = document.querySelectorAll('.dds-tab-btn');
  const tabPanes = document.querySelectorAll('.dds-tab-pane');
  const nameWrapper = document.getElementById('dds-name-wrapper');
  const modalTitle = document.getElementById('dds-modal-title');
  const modalSubtitle = document.getElementById('dds-modal-subtitle');
  
  // Phone Tab
  const phoneStep1 = document.getElementById('dds-phone-step-1');
  const phoneStep2 = document.getElementById('dds-phone-step-2');
  const phoneInput = document.getElementById('dds-phone-input');
  const displayPhone = document.getElementById('dds-display-phone');
  const otpRealInput = document.getElementById('dds-otp-real-input');
  const phoneOtpCells = phoneStep2 ? phoneStep2.querySelectorAll('.dds-otp-cell') : [];
  const btnSendSms = document.getElementById('dds-btn-send-sms');
  const btnVerifyOtp = document.getElementById('dds-btn-verify-otp');
  const btnResendSms = document.getElementById('dds-btn-resend-sms');
  const btnRetryPhone = document.getElementById('dds-btn-retry-phone');
  const phoneErr = document.getElementById('dds-phone-error');
  const otpErr = document.getElementById('dds-otp-error');

  // Email Tab
  const emailStep1 = document.getElementById('dds-email-step-1');
  const emailStep2 = document.getElementById('dds-email-step-2');
  const emailInput = document.getElementById('dds-email-input');
  const displayEmail = document.getElementById('dds-display-email');
  const emailOtpRealInput = document.getElementById('dds-email-otp-real-input');
  const emailOtpCells = emailStep2 ? emailStep2.querySelectorAll('.dds-otp-cell') : [];
  const btnSendEmail = document.getElementById('dds-btn-send-email');
  const btnVerifyEmailOtp = document.getElementById('dds-btn-verify-email-otp');
  const btnResendEmail = document.getElementById('dds-btn-resend-email');
  const btnRetryEmail = document.getElementById('dds-btn-retry-email');
  const emailErr = document.getElementById('dds-email-error');
  const emailOtpErr = document.getElementById('dds-email-otp-error');

  // Funcții Utilitare
  const showError = (el, text) => {
    if (!el) return;
    el.textContent = text;
    el.classList.remove('dds-hidden');
  };
  const hideError = (el) => {
    if (!el) return;
    el.classList.add('dds-hidden');
  };
  const setLoading = (btn, isAct) => {
    if (!btn) return;
    const text = btn.querySelector('.btn-text');
    const loader = btn.querySelector('.btn-loader');
    if (!text || !loader) return;
    if (isAct) {
      btn.disabled = true;
      text.classList.add('dds-hidden');
      loader.classList.remove('dds-hidden');
    } else {
      btn.disabled = false;
      text.classList.remove('dds-hidden');
      loader.classList.add('dds-hidden');
    }
  };

  // --- UI LOGIC ---
  
  // Închiriere / Deschidere Modal
  window.DDS_AUTH = {
    openModal: (mode = 'login') => {
      if (!modal) return;
      setMode(mode);
      modal.classList.remove('dds-hidden');
      document.body.style.overflow = 'hidden';
      // Turnstile: injectare dinamică + renderizare doar când modalul e vizibil
      const tsContainer = document.getElementById('dds-turnstile-widget');
      if (tsContainer && !tsContainer.dataset.rendered) {
        const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        const siteKey = isLocal ? '1x00000000000000000000BB' : '0x4AAAAAADGKT66pIDcMHuBE';

        const doRender = () => {
          if (window.turnstile && !tsContainer.dataset.rendered) {
            window.turnstile.render('#dds-turnstile-widget', {
              sitekey: siteKey,
              appearance: 'interaction-only',
              callback: (token) => { window.ddsTurnstileToken = token; }
            });
            tsContainer.dataset.rendered = 'true';
          }
        };

        if (window.turnstile) {
          // Deja încărcat (ex: a doua oară când se deschide modal-ul)
          doRender();
        } else {
          // Prima deschidere — injectăm scriptul Turnstile dinamic
          const ts = document.createElement('script');
          ts.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
          ts.async = true;
          ts.onload = doRender;
          document.head.appendChild(ts);
        }
      }

    },
    closeModal: () => {
      if (modal) modal.classList.add('dds-hidden');
      document.body.style.overflow = '';
    },
    getSession: async () => {
      if (!window.ddsSupabase) return null;
      const { data } = await window.ddsSupabase.auth.getSession();
      return data.session;
    },
    logout: async () => {
      if (!window.ddsSupabase) return;
      await window.ddsSupabase.auth.signOut();
      window.location.reload();
    }
  };

  if (closeBtn) {
    closeBtn.addEventListener('click', window.DDS_AUTH.closeModal);
  }
  if (modal) {
    modal.addEventListener('click', (e) => {
      if (e.target === modal) window.DDS_AUTH.closeModal();
    });
  }

  // Handle Bottom Nav & Header Triggers
  let isUserLoggedIn = false;
  
  // Check session on load (strict server check for deleted users)
  if (window.ddsSupabase) {
    const fetchAndStoreAddress = async (userId) => {
      
      try {
        const { data, error } = await window.ddsSupabase
          .from('dds_profiles')
          .select('shipping_address')
          .eq('id', userId)
          .single();
        if (data && data.shipping_address) {
          window.localStorage.setItem('dds_shipping_address', JSON.stringify(data.shipping_address));
        }
      } catch (err) {
        console.warn('DDS Auth: Error fetching address', err);
      }
    };

    window.ddsSupabase.auth.getSession().then(async ({ data }) => {
      if (data.session) {
        const { data: user, error } = await window.ddsSupabase.auth.getUser();
        if (error || !user.user) {
          console.warn('DDS Auth: Sesiune locală invalidă. Curățare sesiune.');
          await window.ddsSupabase.auth.signOut();
          isUserLoggedIn = false;
          window.localStorage.removeItem('dds_shipping_address');
        } else {
          isUserLoggedIn = true;
          fetchAndStoreAddress(user.user.id);
        }
      } else {
        isUserLoggedIn = false;
        window.localStorage.removeItem('dds_shipping_address');
      }
    });

    // Listen to session changes
    window.ddsSupabase.auth.onAuthStateChange(async (event, session) => {
      isUserLoggedIn = !!session;
      if (session && session.user) {
        fetchAndStoreAddress(session.user.id);
      } else {
        window.localStorage.removeItem('dds_shipping_address');
      }
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.dds-auth-trigger');
    if (btn) {
      if (!isUserLoggedIn) {
        e.preventDefault(); // Oprește navigarea dacă e <a>
        const customMode = btn.getAttribute('data-auth-mode') || 'login';
        window.DDS_AUTH.openModal(customMode); // Deschide pop-up-ul
      }
      // Daca e logat, lăsăm link-ul/butonul să execute actiunea default
    }
  });

  // --- Mode Selector: Login vs Signup ---
  const setMode = (mode) => {
    currentMode = mode;
    document.querySelectorAll('.dds-mode-btn').forEach(b => b.classList.remove('active'));
    document.getElementById(`dds-mode-${mode}`).classList.add('active');

    if (mode === 'signup') {
      if (nameWrapper) nameWrapper.classList.remove('dds-hidden');
      if (modalTitle) modalTitle.textContent = 'Creează cont nou';
      if (modalSubtitle) modalSubtitle.textContent = 'Completează prenumele și alege cum vrei să te conectezi.';
    } else {
      if (nameWrapper) nameWrapper.classList.add('dds-hidden');
      if (modalTitle) modalTitle.textContent = 'Bine ai revenit!';
      if (modalSubtitle) modalSubtitle.textContent = 'Introdu numărul sau emailul pentru a te conecta instant.';
    }
  };

  document.querySelectorAll('.dds-mode-btn').forEach(btn => {
    btn.addEventListener('click', () => setMode(btn.dataset.mode));
  });

  // Tabs Toggle (Telefon / Email)
  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      tabBtns.forEach(b => b.classList.remove('active'));
      tabPanes.forEach(p => p.classList.remove('active'));
      btn.classList.add('active');
      document.getElementById(btn.dataset.target).classList.add('active');
    });
  });

  // --- PHONE LOGIC ---
  
  if (btnSendSms) {
    btnSendSms.addEventListener('click', async () => {
      hideError(phoneErr);
      let rawVal = phoneInput ? phoneInput.value.trim() : '';

      // extrage doar cifrele si "+" (pentru cei care baga +40 manual)
      let digitsOnly = rawVal.replace(/[^\d+]/g, '');
      
      // Normalizare România
      let formattedPhone = "";
      if (digitsOnly.startsWith('+40')) {
        formattedPhone = digitsOnly;
      } else if (digitsOnly.startsWith('40') && digitsOnly.length === 12) {
        formattedPhone = '+' + digitsOnly;
      } else if (digitsOnly.startsWith('07') && digitsOnly.length === 10) {
        formattedPhone = '+40' + digitsOnly.slice(1);
      } else {
        showError(phoneErr, "Introdu un număr valid (ex: 07XX XXX XXX).");
        return;
      }

      // Anti-Abuse: Validare strictă prefix mobil românesc
      if (!isValidRomanianMobile(formattedPhone)) {
        showError(phoneErr, "Acest număr de telefon nu este valid. Folosește un număr mobil românesc (07XX).");
        return;
      }

      // Anti-Abuse: Client throttle — blochează dublu-click și refresh abuse
      if (isSmsThrottled(formattedPhone)) {
        showError(phoneErr, "Ai trimis deja un cod recent. Așteaptă puțin.");
        return;
      }

      globalCurrentPhone = formattedPhone;
      
      setLoading(btnSendSms, true);

      // Anti-Abuse: Turnstile verification (dacă widget-ul e activ)
      const turnstileToken = window.ddsTurnstileToken;
      const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

      if (turnstileToken && !isLocal) {
        try {
          const validateResp = await fetch(`${SUPABASE_URL}/functions/v1/validate-sms-request`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ turnstile_token: turnstileToken, phone: formattedPhone })
          });
          const validateData = await validateResp.json();
          if (!validateData.allowed) {
            showError(phoneErr, "Verificarea de securitate a eșuat. Reîncarcă pagina și încearcă din nou.");
            setLoading(btnSendSms, false);
            // Reset Turnstile widget
            if (window.turnstile) window.turnstile.reset();
            window.ddsTurnstileToken = null;
            return;
          }
        } catch (e) {
          // Turnstile validation failed (network) — degradare grațioasă, continuăm
          console.warn('Turnstile validate failed, continuing:', e);
        }
        // Reset token after use (one-time)
        window.ddsTurnstileToken = null;
        if (window.turnstile) window.turnstile.reset();
      } else if (turnstileToken && isLocal) {
        // Local development flow: bypass backend verification and reset
        window.ddsTurnstileToken = null;
        if (window.turnstile) window.turnstile.reset();
      }

      // Trimitem full_name DOAR la Signup, nu suprascriem la Login
      const nameInput = document.getElementById('dds-name-input');
      let nameVal = (currentMode === 'signup' && nameInput) ? nameInput.value.trim() : '';
      
      const otpOptions = { phone: formattedPhone, options: { data: { source: 'dds' } } };
      if (nameVal) {
        otpOptions.options.data.full_name = nameVal;
      }
      
      if (!window.ddsSupabase) { showError(phoneErr, "Auth indisponibil."); setLoading(btnSendSms, false); return; }
      const { data, error } = await window.ddsSupabase.auth.signInWithOtp(otpOptions);
      
      setLoading(btnSendSms, false);
      
      if (error) {
        smsFailCount++;
        if (error.message.includes('rate limit') || error.status === 429) {
          currentCooldown = SMS_COOLDOWN_BUSY;
          showError(phoneErr, "Sistemul procesează multe cereri. Încearcă din nou peste 3 minute.");
        } else {
          showError(phoneErr, "Eroare. Verifică numărul și încearcă din nou!");
        }
        // Fallback la email după 3 eșecuri consecutive
        if (smsFailCount >= 3) {
          showError(phoneErr, "SMS-ul nu funcționează momentan. Încearcă prin Email.");
          const emailTab = document.querySelector('.dds-tab-btn[data-target="tab-email"]');
          if (emailTab) emailTab.classList.add('dds-tab-highlight');
        }
        return;
      }

      // Success — resetăm contoarele anti-abuse
      smsFailCount = 0;
      currentCooldown = SMS_COOLDOWN_NORMAL;
      markSmsSent(formattedPhone);

      // Success -> Go to Step 2
      // Afișăm formatul standard local (07XX)
      const displayFormat = "0" + formattedPhone.slice(3);
      if (displayPhone) displayPhone.textContent = displayFormat;
      if (phoneStep1) phoneStep1.classList.add('dds-hidden');
      if (phoneStep2) phoneStep2.classList.remove('dds-hidden');
      // Focus pe input-ul real și resetează vizualul celulelor
      if (otpRealInput) {
        otpRealInput.value = '';
        updateOtpCellsDisplay(phoneOtpCells, '');
        setTimeout(() => otpRealInput.focus(), 50); // mic delay pt render
      }
      startResendTimer();
    });
  }

  if (btnRetryPhone) {
    btnRetryPhone.addEventListener('click', () => {
      if (phoneStep2) phoneStep2.classList.add('dds-hidden');
      if (phoneStep1) phoneStep1.classList.remove('dds-hidden');
      // Reset OTP
      if (otpRealInput) otpRealInput.value = '';
      updateOtpCellsDisplay(phoneOtpCells, '');
      if (phoneInput) phoneInput.focus();
    });
  }

  // === OTP Shared Helpers (compatibil iOS autocomplete + paste) ===

  // Sincronizează celulele vizuale cu ce e în input-ul real
  const updateOtpCellsDisplay = (cellsList, val) => {
    cellsList.forEach((cell, i) => {
      cell.textContent = val[i] || '';
      cell.classList.toggle('filled', !!val[i]);
    });
    // Marchează celula activă
    const activeIdx = Math.min(val.length, 5);
    cellsList.forEach((cell, i) => cell.classList.toggle('active', i === activeIdx && val.length < 6));
  };

  // === PHONE OTP Logic ===

  // Click pe orice celulă telefon → focus pe input real telefon
  if (phoneStep2) {
    phoneOtpCells.forEach(cell => {
      cell.addEventListener('click', () => otpRealInput && otpRealInput.focus());
    });
    phoneStep2.querySelector('.dds-otp-display')?.addEventListener('click', () => otpRealInput && otpRealInput.focus());
  }

  if (otpRealInput) {
    otpRealInput.addEventListener('input', function() {
      // Filtrăm doar cifre
      const clean = this.value.replace(/\D/g, '').substring(0, 6);
      this.value = clean;
      updateOtpCellsDisplay(phoneOtpCells, clean);
      checkPhoneOtpCompleteness();
    });

    otpRealInput.addEventListener('keydown', function(e) {
      if (e.key === 'Backspace') {
        setTimeout(() => {
          updateOtpCellsDisplay(phoneOtpCells, this.value);
          checkPhoneOtpCompleteness();
        }, 0);
      }
    });
  }

  const checkPhoneOtpCompleteness = () => {
    const code = otpRealInput ? otpRealInput.value : '';
    if (code.length === 6) {
      if (btnVerifyOtp) btnVerifyOtp.disabled = false;
      // Auto verify when all 6 digits are in
      verifyOtpMethod(code);
    } else {
      if (btnVerifyOtp) btnVerifyOtp.disabled = true;
      hideError(otpErr);
    }
  };

  const verifyOtpMethod = async (code) => {
    hideError(otpErr);
    setLoading(btnVerifyOtp, true);
    
    if (!window.ddsSupabase) { showError(otpErr, "Auth indisponibil."); setLoading(btnVerifyOtp, false); return; }
    const { data, error } = await window.ddsSupabase.auth.verifyOtp({
      phone: globalCurrentPhone,
      token: code,
      type: 'sms'
    });
    
    setLoading(btnVerifyOtp, false);

    if (error) {
      showError(otpErr, "Cod incorect sau expirat.");
      // Reset vizual
      if (otpRealInput) {
        otpRealInput.value = '';
        updateOtpCellsDisplay(phoneOtpCells, '');
        otpRealInput.focus();
      }
    } else {
      // SUCCESS! Logged in
      btnVerifyOtp.innerHTML = '<span class="btn-text">✅ Conectat</span>';
      btnVerifyOtp.style.background = "#16a34a"; // green
      
      // Update Name explicitly if user filled it out
      const nameInput = document.getElementById('dds-name-input');
      let nameVal = (currentMode === 'signup' && nameInput) ? nameInput.value.trim() : '';
      if (nameVal && data.user) {
        try {
          await window.ddsSupabase.auth.updateUser({
            data: { full_name: nameVal }
          });
        } catch (e) {}
      }

      // Emit custom event
      document.dispatchEvent(new CustomEvent('dds:auth:login', { detail: data.session }));
      
      setTimeout(() => {
        window.location.reload(); // Refresh to update Shopify Header
      }, 800);
    }
  };

  if (btnVerifyOtp) {
    btnVerifyOtp.addEventListener('click', () => {
      const code = otpRealInput ? otpRealInput.value : '';
      verifyOtpMethod(code);
    });
  }

  // Resend Timer SMS — adaptiv: 60s normal, 180s când e aglomerat
  let timerInterval;
  const startResendTimer = (overrideDuration) => {
    let timeLeft = overrideDuration || currentCooldown;
    if (btnResendSms) btnResendSms.disabled = true;
    
    clearInterval(timerInterval);
    // Mesaj adaptat la aglomerație
    if (timeLeft > SMS_COOLDOWN_NORMAL && btnResendSms) {
      btnResendSms.textContent = `Aglomerat — Așteaptă (${timeLeft}s)`;
    }
    timerInterval = setInterval(() => {
      timeLeft--;
      if (btnResendSms) {
        if (timeLeft > SMS_COOLDOWN_NORMAL) {
          btnResendSms.textContent = `Aglomerat — Așteaptă (${timeLeft}s)`;
        } else {
          btnResendSms.textContent = `Așteaptă (${timeLeft}s)`;
        }
      }
      if (timeLeft <= 0) {
        clearInterval(timerInterval);
        if (btnResendSms) {
          btnResendSms.textContent = "Retrimite codul";
          btnResendSms.disabled = false;
        }
      }
    }, 1000);
  };

  if (btnResendSms) {
    btnResendSms.addEventListener('click', async () => {
      hideError(otpErr);
      startResendTimer();
      if (window.ddsSupabase) {
        const { error } = await window.ddsSupabase.auth.signInWithOtp({ phone: globalCurrentPhone });
        if (error && (error.message && (error.message.includes('rate limit') || error.status === 429))) {
          currentCooldown = SMS_COOLDOWN_BUSY;
          startResendTimer(SMS_COOLDOWN_BUSY);
          showError(otpErr, "Sistemul e aglomerat. Codul va fi retrimis automat.");
        } else {
          markSmsSent(globalCurrentPhone);
        }
      }
    });
  }

  // === EMAIL OTP Logic ===

  // Click pe orice celulă email → focus pe input real email
  if (emailStep2) {
    emailOtpCells.forEach(cell => {
      cell.addEventListener('click', () => emailOtpRealInput && emailOtpRealInput.focus());
    });
    emailStep2.querySelector('.dds-otp-display')?.addEventListener('click', () => emailOtpRealInput && emailOtpRealInput.focus());
  }

  if (emailOtpRealInput) {
    emailOtpRealInput.addEventListener('input', function() {
      // Filtrăm doar cifre
      const clean = this.value.replace(/\D/g, '').substring(0, 6);
      this.value = clean;
      updateOtpCellsDisplay(emailOtpCells, clean);
      checkEmailOtpCompleteness();
    });

    emailOtpRealInput.addEventListener('keydown', function(e) {
      if (e.key === 'Backspace') {
        setTimeout(() => {
          updateOtpCellsDisplay(emailOtpCells, this.value);
          checkEmailOtpCompleteness();
        }, 0);
      }
    });
  }

  const checkEmailOtpCompleteness = () => {
    const code = emailOtpRealInput ? emailOtpRealInput.value : '';
    if (code.length === 6) {
      if (btnVerifyEmailOtp) btnVerifyEmailOtp.disabled = false;
      // Auto verify when all 6 digits are in
      verifyEmailOtpMethod(code);
    } else {
      if (btnVerifyEmailOtp) btnVerifyEmailOtp.disabled = true;
      hideError(emailOtpErr);
    }
  };

  const verifyEmailOtpMethod = async (code) => {
    hideError(emailOtpErr);
    setLoading(btnVerifyEmailOtp, true);
    
    if (!window.ddsSupabase) {
      showError(emailOtpErr, "Auth indisponibil.");
      setLoading(btnVerifyEmailOtp, false);
      return;
    }

    const { data, error } = await window.ddsSupabase.auth.verifyOtp({
      email: globalCurrentEmail,
      token: code,
      type: 'email'
    });
    
    setLoading(btnVerifyEmailOtp, false);

    if (error) {
      showError(emailOtpErr, "Cod incorect sau expirat. Verifică emailul.");
      // Reset vizual
      if (emailOtpRealInput) {
        emailOtpRealInput.value = '';
        updateOtpCellsDisplay(emailOtpCells, '');
        emailOtpRealInput.focus();
      }
    } else {
      // SUCCESS! Logged in
      btnVerifyEmailOtp.innerHTML = '<span class="btn-text">✅ Conectat</span>';
      btnVerifyEmailOtp.style.background = "#16a34a"; // green
      
      // Update Name explicitly if user filled it out
      const nameInput = document.getElementById('dds-name-input');
      let nameVal = (currentMode === 'signup' && nameInput) ? nameInput.value.trim() : '';
      if (nameVal && data.user) {
        try {
          await window.ddsSupabase.auth.updateUser({
            data: { full_name: nameVal }
          });
        } catch (e) {}
      }

      // Emit custom event
      document.dispatchEvent(new CustomEvent('dds:auth:login', { detail: data.session }));
      
      setTimeout(() => {
        window.location.reload(); // Refresh to update Shopify Header
      }, 800);
    }
  };

  if (btnVerifyEmailOtp) {
    btnVerifyEmailOtp.addEventListener('click', () => {
      const code = emailOtpRealInput ? emailOtpRealInput.value : '';
      verifyEmailOtpMethod(code);
    });
  }

  // Resend Timer Email (60s)
  let emailTimerInterval;
  const startEmailResendTimer = (duration = 60) => {
    let timeLeft = duration;
    if (btnResendEmail) {
      btnResendEmail.disabled = true;
      btnResendEmail.textContent = `Așteaptă (${timeLeft}s)`;
    }
    
    clearInterval(emailTimerInterval);
    emailTimerInterval = setInterval(() => {
      timeLeft--;
      if (btnResendEmail) {
        btnResendEmail.textContent = `Așteaptă (${timeLeft}s)`;
      }
      if (timeLeft <= 0) {
        clearInterval(emailTimerInterval);
        if (btnResendEmail) {
          btnResendEmail.textContent = "Retrimite codul";
          btnResendEmail.disabled = false;
        }
      }
    }, 1000);
  };

  if (btnSendEmail) {
    btnSendEmail.addEventListener('click', async () => {
      hideError(emailErr);
      const email = emailInput ? emailInput.value.trim() : '';
      if (!email || !email.includes('@') || !email.includes('.')) {
        showError(emailErr, "Introdu o adresă de email validă.");
        return;
      }
      
      globalCurrentEmail = email;
      setLoading(btnSendEmail, true);

      const nameInput = document.getElementById('dds-name-input');
      let nameVal = (currentMode === 'signup' && nameInput) ? nameInput.value.trim() : '';

      const emailOtpOptions = {
        email: email,
        options: {
          data: { source: 'dds' }
        }
      };
      if (nameVal) {
        emailOtpOptions.options.data.full_name = nameVal;
      }
      
      if (!window.ddsSupabase) {
        showError(emailErr, "Auth indisponibil.");
        setLoading(btnSendEmail, false);
        return;
      }

      const { data, error } = await window.ddsSupabase.auth.signInWithOtp(emailOtpOptions);
      
      setLoading(btnSendEmail, false);
      
      if (error) {
        if (error.message && (error.message.includes('rate limit') || error.status === 429)) {
          showError(emailErr, "Prea multe cereri. Așteaptă puțin.");
        } else {
          showError(emailErr, "Eroare la trimitere email. Verifică adresa.");
        }
        return;
      }
      
      // Success -> Go to Step 2
      if (displayEmail) displayEmail.textContent = email;
      if (emailStep1) emailStep1.classList.add('dds-hidden');
      if (emailStep2) emailStep2.classList.remove('dds-hidden');

      if (emailOtpRealInput) {
        emailOtpRealInput.value = '';
        updateOtpCellsDisplay(emailOtpCells, '');
        setTimeout(() => emailOtpRealInput.focus(), 50);
      }
      startEmailResendTimer(60);
    });
  }

  if (btnResendEmail) {
    btnResendEmail.addEventListener('click', async () => {
      hideError(emailOtpErr);
      startEmailResendTimer(60);
      if (window.ddsSupabase && globalCurrentEmail) {
        const { error } = await window.ddsSupabase.auth.signInWithOtp({
          email: globalCurrentEmail,
          options: { data: { source: 'dds' } }
        });
        if (error && (error.message && (error.message.includes('rate limit') || error.status === 429))) {
          showError(emailOtpErr, "Sistemul e aglomerat. Așteaptă înainte de o nouă încercare.");
        }
      }
    });
  }

  if (btnRetryEmail) {
    btnRetryEmail.addEventListener('click', () => {
      if (emailStep2) emailStep2.classList.add('dds-hidden');
      if (emailStep1) emailStep1.classList.remove('dds-hidden');
      if (emailOtpRealInput) emailOtpRealInput.value = '';
      updateOtpCellsDisplay(emailOtpCells, '');
      if (emailInput) emailInput.focus();
    });
  }

});
